import { useContext, useEffect, useMemo, useState } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { useGetContractAndCertificateQuery } from "@/service/ProductService";
import {
  AgGrid,
  ErrorMessage,
  MobileResponsiveGrid,
  Spinner,
} from "@/common/components";

const ContractCertificate = () => {
  const {
    labels,
    setNavHeader,
    setPageHeader,
    location,
    navigate,
    Routes,
    actionsDropdown,
  } = useContext(PrivateContext);

  const [rowData, setRowData] = useState([]);
  const [selectedCertificate, setSelectedCertificate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  const columnDefs = [
    {
      headerName: labels?.contractCertificate?.planName,
      field: "planName",
      flex: 1.5,
    },
    {
      headerName: labels?.contractCertificate?.actions,
      colId: "actions",
      cellRenderer: actionsDropdown,
      cellRendererParams: {
        list: [
          {
            text: labels?.contractCertificate?.viewDetails,
            click: (e) => getDetails(e),
          },
        ],
      },
      sortable: false,
    },
    {
      headerName: labels?.contractCertificate?.planId,
      field: "planId",
      flex: 1.5,
    },
    {
      headerName: labels?.contractCertificate?.recordKeeper,
      field: "recordkeeper",
      flex: 2,
    },
    {
      headerName: labels?.contractCertificate?.contractNumberHeader,
      field: "contractNumber",
    },
    {
      headerName: labels?.contractCertificate?.startingCertificateNumber,
      field: "startingCertificateNumber",
      flex: 1.5,
    },
  ];

  const {
    data: contractDetails,
    isFetching,
    error,
  } = useGetContractAndCertificateQuery({
    productSponsorId: location?.state?.productSponsorId,
    productId: location?.state?.productId,
  });

  const onCellClicked = (e) => {
    if (e.colDef.colId !== "actions") {
      setSelectedCertificate(e.data.planId);
    }
  };

  var getDetails = (params) => {
    const data = rowData.find((e) => e.planId === params.planId);
    navigate(Routes.contractCertificateDetails.path, {
      state: data,
    });
  };

  useEffect(() => {
    if (
      contractDetails &&
      contractDetails?.contractAndCertificateNumberDTOBeans
    ) {
      setRowData(contractDetails?.contractAndCertificateNumberDTOBeans);
    }
  }, [contractDetails]);

  useEffect(() => {
    setPageHeader(labels?.contractCertificate?.title + location?.state?.name);
    setNavHeader(labels?.navbar?.product);
  }, []);

  const overlayNoRowsTemplate = useMemo(
    () =>
      `<div class="ag-overlay-no-rows-center">${
        labels?.contractCertificate?.noData ?? "No data"
      }</div>`,
    [labels]
  );

  return (
    <section className="container-large py-5">
      {isFetching && <Spinner />}
      <ErrorMessage error={error} wrapperClassName="mb-3" />

      <AgGrid
        wrapperClassNames="mb-3 d-none d-md-block"
        columnDefs={columnDefs}
        rowData={rowData}
        domLayout={"normal"}
        onCellClicked={onCellClicked}
        overlayNoRowsTemplate={overlayNoRowsTemplate}
      />

      <MobileResponsiveGrid
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        columnDefs={columnDefs}
        labels={labels?.contractCertificate}
        selectedRowId={selectedCertificate}
        onCellClicked={onCellClicked}
        rowData={rowData}
        showSortDropDown={false}
      />
    </section>
  );
};

export default ContractCertificate;
